/**
 * useAnnouncer — React hook wrapper around the global SR announcer.
 *
 * The underlying live regions live on document.body (see helper/announcer.ts)
 * so they survive popup aria-hidden / inert. This hook just exposes a stable
 * `{ announce, announceError }` API for components.
 *
 * Both functions accept a string and use the double-rAF pattern internally
 * (clear → schedule → write) so repeated identical messages re-announce.
 */
import { useMemo } from 'react';
import { announce as polite, announceAssertive } from '../helper/announcer';
export var useAnnouncer = function () {
    return useMemo(function () { return ({
        announce: function (msg) { return polite(msg); },
        announceError: function (msg) { return announceAssertive(msg); },
    }); }, []);
};
export default useAnnouncer;
